import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { CONFIG } from '../../../../config'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'

const { ENVIROMENT } = CONFIG

const AtivoPatrimonialHttp = {
  baseURL: `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/patrimonio`,

  async fetchAtivos() {
    try {
      const user = getUsuarioInfo()
      const url = this.baseURL + '/ativo-patrimonial/' + user.id
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async fetchAtivosByOwner(ownerId) {
    try {
      const url = this.baseURL + '/ativo-patrimonial/owner/' + ownerId
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async saveAtivo(ativo) {
    try {
      const user = getUsuarioInfo()
      const url = this.baseURL + '/ativo-patrimonial/' + user.id
      const response = await authHttp().post(url, ativo)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async getAssocAtivoLocalMovimentacao(ativo) {
    try {
      const { id: user_id } = getUsuarioInfo()
      const url = `${this.baseURL}/assoc-ativo-patrimonial-local-movimentacao/${ativo.id}/${user_id}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async assocAtivoLocalMovimentacaoHandler(associacao) {
    try {
      const { id: user_id } = getUsuarioInfo()
      const url = this.baseURL + '/assoc-ativo-patrimonial-local-movimentacao/' + user_id
      const response = await authHttp().post(url, associacao)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default AtivoPatrimonialHttp
